<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-ascending-alphabet`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.558 6.447a1 1 0 01.442.83V43a1 1 0 01-1 1h-2a1 1 0 01-1-1V18H4.17a.6.6 0 01-.487-.95L11.01 6.873a1 1 0 01.193-.201l-.033.045a1 1 0 011.388-.271zM40 27a1 1 0 011 1v1.32a1 1 0 01-.343.753l-11.39 9.934H40a1 1 0 011 1V43a1 1 0 01-1 1H24a1 1 0 01-1-1v-1.825a1 1 0 01.343-.754l10.818-9.426H24a1 1 0 01-1-1V28a1 1 0 011-1h16zM33.232 4a1 1 0 01.934.643l6.881 18a1 1 0 01-.934 1.356H38.26a1 1 0 01-.938-.651l-1.244-3.35H26.99l-1.247 3.347a1 1 0 01-.937.65h-1.837a1 1 0 01-.934-1.356l6.877-17.996c.099-.258.41-.473.934-.643h3.386zm-1.66 3.906h-.094l-3.012 8.092h6.127l-3.02-8.092z"/></svg>
</template>
<script>

export default {
  name: 'IconAscendingAlphabet',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
